import { BehaviorSubject } from "rxjs";

import { Store } from "./store";

export type NotificationUnreadCountRealtimeState = {
  unreadCount: number;
  receivedAt: number;
};

export class NotificationUnreadCountRealtimeStore extends Store<NotificationUnreadCountRealtimeState> {
  protected _observable: BehaviorSubject<NotificationUnreadCountRealtimeState | null>;
  private static _instance?: NotificationUnreadCountRealtimeStore;

  public static getInstance() {
    NotificationUnreadCountRealtimeStore._instance =
      NotificationUnreadCountRealtimeStore._instance ||
      new NotificationUnreadCountRealtimeStore();
    return NotificationUnreadCountRealtimeStore._instance;
  }

  private constructor() {
    super();
    this._observable =
      new BehaviorSubject<NotificationUnreadCountRealtimeState | null>(null);
  }
}
